import React from 'react'
import Schuco from '../schuco'
import Windows1 from './windows1'
import Windows2 from './windows2'
import { Container, Jumbotron, Col, Row } from 'reactstrap'
import '../../Offer/offer.css'
import Facades1 from './facades1'
import Gardens1 from './gardens1'
import Gardens2 from './gardens2'

var Translate = require('react-translate-component')

const styles = {
  nonSelected: { backgroundColor: '#D8DEE2', color: '#808A94' },
  selected: { backgroundColor: '#FFFFFF', color: '#1D2C34' }
}

export default class constructionContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showWindows: true,
      showFacades: false,
      showGardens: false,
      width: window.innerWidth
    }
  }

  componentWillMount () {
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }

  triggerShowWindows = () => {
    this.setState({
      ...this.state,
      showWindows: true,
      showFacades: false,
      showGardens: false
    })
  }
  triggerShowFacades = () => {
    this.setState({
      ...this.state,
      showWindows: false,
      showFacades: true,
      showGardens: false
    })
  }
  triggerShowGardens = () => {
    this.setState({
      ...this.state,
      showWindows: false,
      showFacades: false,
      showGardens: true
    })
  }

  render () {
    return (
      <Jumbotron id='jumbotronWhite'>
        <Container>
          {this.state.width > 768 && (
            <Row id='typesRow'>
              <Col id='tabCol'>
                <div
                  class='tab'
                  style={
                    this.state.showWindows
                      ? styles.selected
                      : styles.nonSelected
                  }
                  onClick={() => this.triggerShowWindows()}
                >
                  <Translate content='okna_i_drzwi_przesuwne' />
                </div>
              </Col>
              <Col id='tabCol'>
                <div
                  class='tab'
                  style={
                    this.state.showFacades
                      ? styles.selected
                      : styles.nonSelected
                  }
                  onClick={() => this.triggerShowFacades()}
                >
                  <Translate content='fasady_szklane' />
                </div>
              </Col>
              <Col id='tabCol'>
                <div
                  class='tab'
                  style={
                    this.state.showGardens
                      ? styles.selected
                      : styles.nonSelected
                  }
                  onClick={() => this.triggerShowGardens()}
                >
                <Translate content='ogrody_zimowe' />
                </div>
              </Col>
            </Row>
          )}

          {this.state.width < 768 && (
            <Container>
              <Row>
                <div
                  class='tab'
                  style={
                    this.state.showWindows
                      ? styles.selected
                      : styles.nonSelected
                  }
                  onClick={() => this.triggerShowWindows()}
                >
                  <Translate content='okna_i_drzwi_przesuwne' />
                </div>
              </Row>
              <Row>
                <div
                  class='tab'
                  style={
                    this.state.showFacades
                      ? styles.selected
                      : styles.nonSelected
                  }
                  onClick={() => this.triggerShowFacades()}
                >
                  <Translate content='fasady_szklane' />
                </div>
              </Row>
              <Row>
                <div
                  class='tab'
                  style={
                    this.state.showGardens
                      ? styles.selected
                      : styles.nonSelected
                  }
                  onClick={() => this.triggerShowGardens()}
                >
                  <Translate content='ogrody_zimowe' />
                </div>
              </Row>
            </Container>
          )}
        </Container>
        <Container>
          {this.state.showWindows && <Windows1 />}
          {this.state.showFacades && <Facades1 />}
          {this.state.showGardens && <Gardens1 />}

          {this.state.showWindows && <Windows2 />}
          {/* {this.state.showFacades && <Facades2 />} */}
          {this.state.showGardens && <Gardens2 />}
          <Schuco />
        </Container>
      </Jumbotron>
    )
  }
}
